import { render, staticRenderFns } from "./KanbanTaskFile.vue?vue&type=template&id=54b0b1d0&scoped=true&"
import script from "./KanbanTaskFile.vue?vue&type=script&lang=js&"
export * from "./KanbanTaskFile.vue?vue&type=script&lang=js&"
import style0 from "./KanbanTaskFile.vue?vue&type=style&index=0&id=54b0b1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0b1d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b0b1d0')) {
      api.createRecord('54b0b1d0', component.options)
    } else {
      api.reload('54b0b1d0', component.options)
    }
    module.hot.accept("./KanbanTaskFile.vue?vue&type=template&id=54b0b1d0&scoped=true&", function () {
      api.rerender('54b0b1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/KanbanTaskFile.vue"
export default component.exports